/** Raumbeschriftungen: Flächen aus den Plänen, Namen kann man im Grundriss vergeben. */
import * as THREE from "three";
import { FLOORS } from "./constants";

export interface RoomDef { key: string; f: number; x: number; y: number; area: string; def: string }

const RAW: [number, number, number, string, string][] = [
  [0, 5.22, 8.73, "17,08 m²", ""], [0, 1.53, 8.58, "8,95 m²", ""], [0, 2.28, 5.85, "5,25 m²", ""], [0, 2.6, 4.55, "10,22 m²", "Flur"],
  [0, 2.28, 2.1, "14,26 m²", ""], [0, 5.97, 1.1, "4,72 m²", "Eingang"], [0, -1.7, 6.3, "ca. 30 m²", "Garage"],
  [1, 3.8, 8.6, "30,10 m²", ""], [1, 1.6, 5.3, "10,01 m²", ""], [1, 1.7, 2.1, "14,61 m²", ""], [1, 3.75, 1.1, "ca. 1,7 m²", ""],
  [1, 5.3, 1.1, "2,81 m²", ""], [1, 6.86, 1.1, "1,89 m²", ""], [1, 5.3, 3.8, "5,65 m²", "Flur"], [1, -1.8, 5.9, "Garagendach", "Terrasse"],
  [2, 2.3, 8.5, "14,98 m²", ""], [2, 6.0, 8.2, "14,43 m²", ""], [2, 1.3, 5.3, "5,09 m²", ""], [2, 3.4, 5.0, "10,59 m²", "Flur"],
  [2, 2.3, 2.1, "14,44 m²", ""], [2, 6.0, 1.1, "4,85 m²", ""], [2, 2.1, 11.55, "6,64 m²", "Balkon"],
  [3, 2.3, 6.0, "40,18 m²", ""], [3, 6.0, 8.2, "14,41 m²", ""], [3, 5.3, 3.6, "5,69 m²", "Flur"], [3, 6.0, 1.1, "niedrig", "Abseite"],
  // neue Einträge nur hinten anhängen (Schlüssel = Position)
  [3, 2.3, 1.1, "niedrig", "Abseite"], [3, 2.3, 9.9, "niedrig", "Abseite"], [3, 6.0, 9.9, "niedrig", "Abseite"],
];
/** Schlüssel r0, r1 … (planung.ts verweist darauf, z. B. removeRoomLabel("r8")). */
export const ROOMS: RoomDef[] = RAW.map(([f, x, y, area, def], i) => ({ key: "r" + i, f, x, y, area, def }));

export function drawLabel(cv: HTMLCanvasElement, name: string, area: string) {
  const g = cv.getContext("2d")!; g.clearRect(0, 0, cv.width, cv.height);
  g.fillStyle = "rgba(255,255,255,0.82)"; g.fillRect(0, 18, cv.width, cv.height - 36);
  g.strokeStyle = "#1d2421"; g.lineWidth = 3; g.strokeRect(1.5, 19.5, cv.width - 3, cv.height - 39);
  g.fillStyle = "#1d2421"; g.textAlign = "center"; g.textBaseline = "middle";
  g.font = '600 54px "IBM Plex Sans Condensed","Arial Narrow",sans-serif'; g.fillText(name || "Raum", cv.width / 2, 64);
  g.fillStyle = "#24578a"; g.font = '600 44px "IBM Plex Mono",monospace'; g.fillText(area, cv.width / 2, 114);
}

export interface LabelMesh extends THREE.Mesh { userData: { room: RoomDef; cv: HTMLCanvasElement; tex: THREE.CanvasTexture } }

export function makeLabel(room: RoomDef, name: string): LabelMesh {
  const cv = document.createElement("canvas"); cv.width = 360; cv.height = 156;
  drawLabel(cv, name || room.def, room.area);
  const tex = new THREE.CanvasTexture(cv); tex.colorSpace = THREE.SRGBColorSpace; tex.anisotropy = 4;
  const a = room.area;
  const small = a.startsWith("1,") || a.startsWith("2,") || a.startsWith("ca. 1") || a.startsWith("4,");
  const w = small ? 1.25 : 2.1;
  const m = new THREE.Mesh(new THREE.PlaneGeometry(w, (w * 156) / 360), new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false })) as unknown as LabelMesh;
  m.rotation.x = -Math.PI / 2;
  const z = room.f === 1 && room.def === "Terrasse" ? 2.62 : room.f === 2 && room.def === "Balkon" ? 5.37 : FLOORS[room.f].z;
  m.position.set(room.x, z + 0.03, -room.y); m.renderOrder = 5;
  m.userData = { room, cv, tex };
  return m;
}

export function refreshLabel(m: LabelMesh, name: string) {
  drawLabel(m.userData.cv, name || m.userData.room.def, m.userData.room.area);
  m.userData.tex.needsUpdate = true;
}
